import * as React from "react";

export const HomeContext = React.createContext(null);
